<template>
  <div class="text-xs">
    <span>{{ t(`${trPrefix}signInAgreement`) }}&nbsp;</span>

    <NuxtLink
      class="font-medium underline hover:no-underline cursor-pointer"
      target="_blank"
      :to="pplink"
      external
    >
      {{ t(`${trPrefix}privacyPolicy`) }}
    </NuxtLink>

    <span>{{ t(`${trPrefix}signInAgreementEnd`) }}</span>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
const runTimeConfig = useRuntimeConfig()
const trPrefix = 'components.auth.login.userAgreement.'

const pplink = ref<string>(runTimeConfig.public.privacyPolicyLink)
</script>

<style scoped></style>
